import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

const STATUS_STYLES: Record<string, string> = {
  draft: "bg-muted text-muted-foreground border-border",
  under_review: "bg-amber-100 text-amber-800 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
  ganho: "bg-emerald-100 text-emerald-800 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-900",
  perdido: "bg-red-100 text-red-800 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-900",
  sent: "bg-sky-100 text-sky-800 border-sky-200 dark:bg-sky-950 dark:text-sky-300 dark:border-sky-900",
}

const STATUS_LABELS: Record<string, string> = {
  draft: "Draft",
  under_review: "Em revisão",
  ganho: "Ganho",
  perdido: "Perdido",
  sent: "Enviada",
}

/** Public read of labels + ordered keys so editor/dropdown UIs stay in sync. */
export const SIMULATION_STATUS_ORDER = [
  "draft",
  "under_review",
  "sent",
  "ganho",
  "perdido",
] as const

export function statusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status
}

export function StatusBadge({ status }: { status: string }) {
  return (
    <Badge
      variant="outline"
      className={cn("border", STATUS_STYLES[status] ?? STATUS_STYLES.draft)}
    >
      {STATUS_LABELS[status] ?? status}
    </Badge>
  )
}
